export function toEchartData(respostas) {
  if (!respostas || respostas.length === 0) {
    return { legends: [], data: [] };
  }

  const data = respostas.map((resposta, index) => ({
    value: resposta.resultado_percentual,
    numeric: resposta.resultado_numerico,
    name: resposta.enunciado,
    label: resposta.linha,
  }))
    .sort((d1, d2) => d1.numeric - d2.numeric);

  const legends = [...new Set(data.map((value) => value.name).reverse())];

  return {
    legends,
    data,
  };
}
